import { type HttpClient } from '../useHttpClient';

export type PostUnitInsightLlmChatMessageStreamChunk =
  | {
      type: 'chat-info';
      data: { chatId: number };
    }
  | {
      type: 'chat-message-chunk';
      data: { text: string };
    }
  | {
      type: 'chat-message-end';
      data: {
        userMessageId: number;
        assistantMessageId: number;
      };
    };

export const postUnitInsightLlmChatMessage =
  (httpClient: HttpClient) =>
  async ({
    unitId,
    insightId,
    chatId,
    message,
    fileUrls,
  }: {
    unitId: string | number;
    insightId: string | number;
    chatId: number | undefined;
    message: string;
    fileUrls: string[];
  }) => {
    const response =
      await httpClient.restApiKpis<PostUnitInsightLlmChatMessageStreamChunk>(
        `/kpis/unit/${unitId}/insights/llm/${insightId}/chat-messages`,
        {
          method: 'POST',
          body: JSON.stringify({
            chatId,
            message,
            fileUrls,
          }),
        }
      );

    return response;
  };
